import axios from 'axios';
//import { DEFAULT_HEADER, API_URL, JWT_TOKEN, JWT_REFRESH_TOKEN, WORKER_ID, CS_ID } from '../../const';

import { CONSTRUCTION, CONSTRUCTION_NM, DEFAULT_HEADER, NAME, TYPE } from '../../const';
import router from '../../router';
import store from '../../store/modules/facemapping';
const API_URL = process.env.API_URL;
//import authHeader from '../../api/Header';
// If you need global defaults, use:
//axios.defaults.baseURL = '/api';
// axios.defaults.headers.common['Accept-Encoding'] = 'gz';
// ...

// TODO: if we need, use a serverinfo,
// TODO: and if question, account Client same setting, they must be used together.

export const httpClient = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    timeout: 3000,
    headers: {
        ...DEFAULT_HEADER
    }
});

httpClient.interceptors.response.use(undefined, function(error) {
    const res = error.response ? error.response : null;
    store.state.isLoading = false;
    if (res == null) {
        alert('오류가 발생했습니다. 다시 시도해 주십시오.1');
        return Promise.reject(error);
    }

    if (res.status === 500) {
        if (res.data.code === 'err.session.001') {
            localStorage.removeItem(CONSTRUCTION_NM);
            localStorage.removeItem(CONSTRUCTION);
            localStorage.removeItem(NAME);
            localStorage.removeItem(TYPE);
            alert(res.data.msg);
            router.push({ name: 'Login' });
            return Promise.reject(error);
        }
        if (res.data.code === 'err.auth.002' || res.data.code === 'err.access.001') {
            alert(res.data.msg);
            router.push({ name: 'Login' });
            return Promise.reject(error);
        }
        alert(res.data.msg);
    } else {
        alert('오류가 발생했습니다. 다시 시도해 주십시오.');
    }
    return Promise.reject(error);
});
export const httpClientOnlyRefresh = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    timeout: 3000,
    headers: {
        ...DEFAULT_HEADER
    }
});

export const uploadClient = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
});

export const downloadClient = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        ...DEFAULT_HEADER
    },
    responseType: 'blob'
});
